import { useEffect, useState } from "react";
import Layout from "./common/Layout";
import Back from "./common/Back";
import { useTranslation } from "react-i18next";
import {
  useApi,
  useEmail,
  useIsOnboardedWithEmail,
  useOnboardingId,
} from "../store/hooks";
import { useNavigate } from "react-router-dom";
import Spinner from "./common/Spinner";
import Toast from "./common/Toast";

const EmailVerification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const filledEmail = useEmail();
  const isOboardedWithEmail = useIsOnboardedWithEmail();
  const { patchOnboarding, sendOtp } = useApi();

  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isError, setIsError] = useState(false);

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const isEmailValid = (email) => {
    if (typeof email !== "string" || email.trim() === "") return false;
    return emailRegex.test(email.trim());
  };

  const handleChange = (e) => {
    setIsValidEmail(isEmailValid(e.target.value));
    setEmail(e.target.value);
  };

  const confirmEmail = async () => {
    try {
      setIsProcessing(true);
      if (!isOboardedWithEmail) {
        await patchOnboarding({ email: email });
      }
      await sendOtp();
      navigate("/OtpCheck");
    } catch (error) {
      console.error("Error confirming Email:", error);
      setIsError(true);
      setIsProcessing(false);
    }
  };

  const handleSubmit = () => {
    if (isValidEmail && !isProcessing) confirmEmail();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleGlobalKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  useEffect(() => {
    if (isOboardedWithEmail) setEmail(filledEmail);
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleGlobalKeyDown);

    return () => {
      document.removeEventListener("keydown", handleGlobalKeyDown);
    };
  }, [isValidEmail, isProcessing]);

  return (
    <>
      <Layout>
        <div className="az-title">{t("emailForm.title")}</div>

        <Toast text={t("global.toast.text")} />

        <div className="az-subtitle mt-4">{t("emailForm.subtitle")}</div>

        <div className="mt-2">
          <form>
            <div
              className={
                !isValidEmail
                  ? "az-formfield az-formfield--error"
                  : "az-formfield"
              }
            >
              <input
                type="email"
                className="az-formfield__input"
                id="email"
                name="email"
                placeholder=" "
                value={email}
                disabled={isOboardedWithEmail}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
              />
              <label className="az-formfield__label" htmlFor="email">
                {t("emailForm.input.label")}
              </label>
            </div>

            <div
              className={`az-btn text-uppercase mt-5 ${isValidEmail ? "" : "disabled"} ${isProcessing ? "disabled" : ""}`}
              onClick={handleSubmit}
            >
              {isProcessing ? <Spinner size={24} /> : t("emailForm.btn.label")}
            </div>

            {!isValidEmail && (
              <div className="error-message">
                {t("emailForm.invalid.error")}
              </div>
            )}
          </form>
        </div>

        {isError && (
          <div className="error-message-container mt-4">
            <span className="error-message not-received-span">
              {t("errorPage.message")} {t("errorPage.subMessage")}
            </span>
          </div>
        )}

        <Back message={t("back.label")} />
      </Layout>
    </>
  );
};

export default EmailVerification;
